export const prettifyExt = (pretty) => () => [{
	type: 'output',
	regex: /<pre><code( class="[a-zA-Z0-9 _-]*")*>([^]*?)<\/code><\/pre>/gi,
	replace: (matchedText) => {
		return `<pre class="prettyprint linenums"><code>${pretty(matchedText.match(/<pre><code( class="[a-zA-Z0-9 _-]*")*>([^]*?)<\/code><\/pre>/)[2], '', true)}</code></pre>`;
	}
}];

export const calloutExt = () => [{
	type: 'output',
	regex: /(<p>@@@+\[.*]|@@@+\[.*])([^]*?)(@@@<\/p>|@@@)/gi,
	replace: (matchedText, startSymbol, content) => {
		const title = startSymbol.substring(startSymbol.lastIndexOf('[') + 1, startSymbol.lastIndexOf(']'));
		const clearedContent = content.replace(/<p>|<\/p>|<p><\/p>/g, '');
		const hasCodeAsContent = content.indexOf('<pre>') > -1;

		return '<div class="showdown-callout' + (hasCodeAsContent ? ' showdown-code' : '') + '"><header>' + title + '</header><div class="showdown-callout-body">' + clearedContent + '</div></div>';
	}
}];

export const alertExt = () => [{
	type: 'output',
	regex: /(<p>!!!+|!!!+)([^]*?)(!!!<\/p>|!!!)/g,
	replace: (matchedText, startSymbol, content) => '<div class="showdown-alert">' + content + '</div>'
}];



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/helpers/showdown/extensions.ts